<template>
  <q-dialog
    :visible="isVisible"
    title="预估调整量导出"
    width="520px"
    :inner-scroll="false"
    :loading="loading"
    @confirm="confirm"
    @cancel="cancel"
    @close="cancel"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="月份" prop="planTime">
        <el-date-picker
          v-model="form.planTime"
          type="month"
          value-format="yyyy-MM"
          placeholder="请选择月份"
          @change="handlePlanTimeChange"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="店铺" prop="storeId">
        <el-select v-model="form.storeId" clearable filterable placeholder="请选择店铺">
          <el-option v-for="item in storeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </q-dialog>
</template>

<script>
import moment from 'moment';

export default {
  name: 'PlanAdjustExportDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      storeOptions: [],
      form: {
        planTime: moment().add(1, 'month').format('YYYY-MM'),
        storeId: '',
      },
      rules: {
        planTime: [{ required: true, message: '请选择月份', trigger: 'change' }],
        storeId: [{ required: true, message: '请选择店铺', trigger: 'change' }],
      },
    };
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
  },
  created() {
    this.getStoreOptions();
  },
  methods: {
    handlePlanTimeChange() {
      this.form.storeId = '';
      this.getStoreOptions();
    },
    getStoreOptions() {
      this.storeOptions = [];
      if (!this.form.planTime) return;

      this.$q.preSalePlan.getMonthStore({
        params: {
          month: moment(this.form.planTime).month() + 1,
        },
      }).then((res) => {
        if (res.code == 200 && res.data) {
          this.storeOptions = Object.keys(res.data).map((key) => ({
            label: res.data[key],
            value: key,
          }));
          if (this.storeOptions.length === 1) {
            this.form.storeId = this.storeOptions[0].value;
          }
        }
      });
    },
    cancel() {
      this.isVisible = false;
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        this.$emit('export', { ...this.form });
        this.loading = false;
        this.cancel();
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .el-date-editor, >>> .el-select
  width 280px
</style>
